(() => {
  const SEL = ".junip-product-summary-review-count";

  const format = (el) => {
    const raw = (el.textContent || "").trim();

    // deja solo dígitos: "(1,074)" -> "1074"
    const digits = raw.replace(/[^\d]/g, "");
    if (!digits) return;

    const n = Number(digits);
    const label = n === 1 ? "review" : "reviews";
    const desired = `${n} ${label}`;

    if (el.textContent === desired) return;
    el.textContent = desired;
  };

  const run = (root = document) => {
    root.querySelectorAll?.(SEL).forEach(format);
    if (root.matches?.(SEL)) format(root);
  };

  run();

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === "childList") {
        m.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          run(node);
        });
      } else if (m.type === "characterData") {
        const parent = m.target.parentElement;
        if (parent?.matches?.(SEL)) format(parent);
      }
    }
  });

  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    characterData: true,
  });
})();